import request from "../utils/businessservice";
///获取对象
export function getWarrantyList(data) {
  return request({
    url: "/supervision/complant/estateReportingWarrantyList?pageNum=" + data.page + "&pageSize=" + data.pageSize + "&estateId=" + data.communityId, ///测试Api地址
    method: "get",
  });
}

export function getWarrantyInfo(data) {
  return request({
    url: "/supervision/complant/reportingWarranty/" + data.id, ///测试Api地址
    method: "get",
  });
}
